import { cn } from "@/utils/cn";
import { memo } from "react";

interface CalorieLegendProps {
  name: string;
  percentage: number;
  colorClassName: string;
}

export const CalorieLegend = memo(function CalorieLegend({
  name,
  percentage,
  colorClassName,
}: CalorieLegendProps) {
  return (
    <div className="flex items-center justify-between py-2">
      <div className="flex items-center gap-3">
        <div className={cn("w-4 h-4 rounded-full", colorClassName)}></div>
        <span className="text-base">{name}</span>
      </div>
      <span className="text-sm font-medium text-gray-400">
        {Math.round(percentage)}%
      </span>
    </div>
  );
});
